/* ============================================================
   サイン会メッセージ入力フォーム
   - カウンター / blurバリデーション / 確認モーダル
   - バリアント切替で表示・必須を再構成（入力値は保持）
   - 送信は capture phase で横取りし、検証OK＋確認後に既存(Alpine)の
     カート追加処理へ通す
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    var form = root.closest('form[data-product-form]') || root.closest('form');
    if (!form) return;

    var strings = document.querySelector('[data-signing-strings]');
    var T = {
      btnhint: strings ? strings.getAttribute('data-btnhint') : '',
      req: strings ? strings.getAttribute('data-req') : '必須',
      opt: strings ? strings.getAttribute('data-opt') : '任意'
    };

    var fields = {};
    root.querySelectorAll('[data-sf-field]').forEach(function (f) {
      fields[f.getAttribute('data-sf-field')] = {
        el: f,
        input: f.querySelector('[data-sf-input]'),
        counter: f.querySelector('[data-sf-counter]'),
        error: f.querySelector('[data-sf-error]'),
        badge: f.querySelector('[data-sf-badge]'),
        step: f.querySelector('[data-sf-step]'),
        max: parseInt(f.querySelector('[data-sf-input]').getAttribute('maxlength'), 10) || 100
      };
    });

    var variantMap = {};
    var vjson = root.querySelector('[data-signing-variants]');
    if (vjson) { try { variantMap = JSON.parse(vjson.textContent); } catch (e) {} }

    var addBtn = form.querySelector('.add-to-cart-btn') || form.querySelector('button[type="submit"]');

    var hint = document.createElement('div');
    hint.className = 'signing-form-btnhint';
    hint.textContent = T.btnhint;
    if (addBtn && addBtn.parentNode) {
      addBtn.parentNode.insertBefore(hint, addBtn.nextSibling);
    }

    var modal = document.querySelector('[data-signing-modal]');
    var modalBody = modal ? modal.querySelector('[data-signing-modal-body]') : null;
    var confirmed = false;

    function isVisible(f) { return f.el.style.display !== 'none'; }
    function isRequired(f) { return f.el.getAttribute('data-sf-mode') === '必須'; }

    function updateCounter(f) {
      var len = f.input.value.length;
      f.counter.textContent = len + ' / ' + f.max;
      f.counter.classList.toggle('is-over', len > f.max);
    }

    function anyOver() {
      return Object.keys(fields).some(function (k) {
        var f = fields[k];
        return isVisible(f) && f.input.value.length > f.max;
      });
    }

    function refreshBtn() {
      if (!addBtn) return;
      if (anyOver()) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        if (!addBtn.hasAttribute('data-sf-soldout')) {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        }
      }
    }

    function validateField(f) {
      if (!isVisible(f)) { f.el.classList.remove('is-error'); return true; }
      var v = f.input.value.trim();
      var ok = true;
      if (isRequired(f) && v === '') ok = false;
      if (f.input.value.length > f.max) ok = false;
      f.el.classList.toggle('is-error', !ok);
      return ok;
    }

    function setMode(f, mode) {
      f.el.setAttribute('data-sf-mode', mode);
      if (mode === '非表示') {
        f.el.style.display = 'none';
        f.input.disabled = true;
        f.el.classList.remove('is-error');
        return;
      }
      f.el.style.display = '';
      f.input.disabled = false;
      if (mode === '任意') {
        f.badge.textContent = T.opt;
        f.badge.className = 'signing-form__badge signing-form__badge--opt';
      } else {
        f.badge.textContent = T.req;
        f.badge.className = 'signing-form__badge signing-form__badge--req';
      }
    }

    function renumber() {
      var visible = Object.keys(fields).map(function (k) { return fields[k]; }).filter(isVisible);
      root.style.display = visible.length ? '' : 'none';
      var n = 0;
      visible.forEach(function (f) {
        n++;
        if (f.step) {
          f.step.textContent = n;
          f.step.style.display = visible.length >= 2 ? '' : 'none';
        }
      });
      refreshBtn();
    }

    function applyVariant(variantId) {
      var cfg = variantMap[String(variantId)];
      if (!cfg) return;
      if (fields.name) setMode(fields.name, cfg.name);
      if (fields.message) setMode(fields.message, cfg.message);
      renumber();
    }

    var idSelect = form.querySelector('select[name="id"]');
    function currentVariantId() {
      try {
        var v = new URLSearchParams(window.location.search).get('variant');
        if (v) { return v; }
      } catch (e) {}
      return idSelect ? idSelect.value : null;
    }
    function syncVariant() { applyVariant(currentVariantId()); }
    if (idSelect) {
      idSelect.addEventListener('change', function () {
        syncVariant();
        requestAnimationFrame(syncVariant);
      });
    }
    syncVariant();

    Object.keys(fields).forEach(function (k) {
      var f = fields[k];
      f.input.addEventListener('input', function () {
        updateCounter(f); refreshBtn();
        if (f.el.classList.contains('is-error')) validateField(f);
      });
      f.input.addEventListener('blur', function () { validateField(f); });
      updateCounter(f);
    });

    function openModal() {
      if (!modal) return;
      var html = '';
      Object.keys(fields).forEach(function (k) {
        var f = fields[k];
        if (!isVisible(f)) return;
        var label = f.el.querySelector('.signing-form__label');
        var val = f.input.value.trim();
        html += '<dl class="signing-form-modal__row"><dt>' + (label ? label.textContent : k) +
                '</dt><dd>' + escapeHtml(val || '—') + '</dd></dl>';
      });
      if (!html) html = '<p class="signing-form-modal__empty">—</p>';
      if (modalBody) modalBody.innerHTML = html;
      modal.hidden = false;
    }
    function closeModal() { if (modal) modal.hidden = true; }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function pruneInputs() {
      Object.keys(fields).forEach(function (k) {
        var f = fields[k];
        f.input.value = f.input.value.trim();
        if (!isVisible(f) || f.input.value === '') {
          f.input.disabled = true;
        } else {
          f.input.disabled = false;
        }
      });
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) { return; }
      if (confirmed) { confirmed = false; return; }

      var visible = Object.keys(fields).map(function (kk) { return fields[kk]; }).filter(isVisible);
      if (visible.length === 0) { return; }

      var ok = true;
      visible.forEach(function (f) { if (!validateField(f)) ok = false; });

      if (!ok) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hint.classList.add('is-show');
        var firstErr = root.querySelector('.signing-form__field.is-error');
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      hint.classList.remove('is-show');

      e.preventDefault();
      e.stopImmediatePropagation();
      openModal();
    }, true);

    if (modal) {
      var editBtn = modal.querySelector('[data-signing-modal-edit]');
      var confBtn = modal.querySelector('[data-signing-modal-confirm]');
      if (editBtn) editBtn.addEventListener('click', closeModal);
      if (confBtn) confBtn.addEventListener('click', function () {
        closeModal();
        pruneInputs();
        confirmed = true;
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          var ev = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(ev);
        }
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    }

    renumber();
  }

  function boot() {
    document.querySelectorAll('[data-signing-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();